import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
// import { useResponsive } from '../../../services/hooks';
import { IconButton, Modal, Card, CardContent, CardHeader, Portal, Stack, Box, FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const DetailDialog = ({ isOpen, onClose, DetailCallbackComponent, showStatePanel, objectData, handleChangeStateCallback }) => {
  let title = '';
  if (objectData?.name) {
    title = `${objectData?.name} ${objectData?.surname}`;
  } else if (objectData?.operation_type) {
    title = `Zasilenie umowy ${objectData?.agreement}`;
  }

  return (
    <Portal>
      <Modal open={isOpen} onClose={onClose}>
        <Card
          sx={{
            ...style,
            width: '95vw',
            maxWidth: '1350px',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <CardHeader title={title} action={
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
              <Box width={40} />
              <Box sx={{ flexGrow: 1 }} />
              {showStatePanel
                ? <FormControl size="small" sx={{ width: '210px' }}>
                  <InputLabel id="state-label">Status</InputLabel>
                  <Select
                    labelId="state-label"
                    id="state"
                    value={objectData.state || ''}
                    label="state"
                    onChange={e => handleChangeStateCallback(e.target.value)}
                  >
                    {_.map(objectData.states, (state, code) => (
                      <MenuItem key={code} value={code}>{state}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                : null}
              <IconButton onClick={onClose} aria-label="close window">
                <CloseIcon />
              </IconButton>
            </Stack>
          }/>
          <CardContent sx={{
            flex: 1,
            overflow: 'auto'
          }}
          >
            {DetailCallbackComponent}
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
DetailDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  detailCallbackComponent: PropTypes.element.isRequired
};

export default DetailDialog;
